import Nanobus from "nanobus";
var Sidebox = /** @class */ (function () {
    function Sidebox(el) {
        this.el = el;
        this.events = new Nanobus();
        this.Form = new NewLayoutForm(el.querySelector('.new'));
        this.initEvents();
    }
    Sidebox.prototype.onOrdered = function (cb) {
        this.events.addListener('ordered', cb);
    };
    Sidebox.prototype.getListScreen = function () {
        return this.el.dataset.type;
    };
    Sidebox.prototype.initEvents = function () {
        var _this = this;
        var button = this.getButton();
        if (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                if (button.classList.contains('open')) {
                    _this.cancelNewLayout();
                }
                else {
                    _this.addNewLayout();
                }
            });
        }
        jQuery(this.el).find('.layouts__items').sortable({
            items: '.layouts__item',
            axis: 'y',
            containment: jQuery(this.el).find('.layouts__items'),
            handle: '.cpacicon-move',
            stop: function () {
                _this.setNewOrder();
            }
        });
    };
    Sidebox.prototype.setNewOrder = function () {
        var _this = this;
        this.storeLayoutOrder(this.getOrder()).done(function () {
            _this.events.emit('ordered', _this.getOrder());
        });
    };
    Sidebox.prototype.getOrder = function () {
        var order = [];
        this.el.querySelectorAll('.layouts__item').forEach(function (layout) {
            order.push(layout.dataset.screen);
        });
        return order;
    };
    Sidebox.prototype.storeLayoutOrder = function (order) {
        return jQuery.ajax({
            url: ajaxurl,
            method: 'POST',
            data: {
                _ajax_nonce: AC._ajax_nonce,
                action: 'acp_update_layout_order',
                list_screen: this.getListScreen(),
                order: order
            }
        });
    };
    Sidebox.prototype.getButton = function () {
        return this.el.querySelector('a.add-new');
    };
    Sidebox.prototype.addNewLayout = function () {
        this.getButton().classList.add('open');
        this.Form.open();
    };
    Sidebox.prototype.cancelNewLayout = function () {
        this.getButton().classList.remove('open');
        this.Form.close();
    };
    return Sidebox;
}());
export default Sidebox;
var NewLayoutForm = /** @class */ (function () {
    function NewLayoutForm(el) {
        this.el = el;
        this.initEvents();
    }
    NewLayoutForm.prototype.open = function () {
        jQuery(this.el).slideDown();
    };
    NewLayoutForm.prototype.close = function () {
        jQuery(this.el).slideUp();
    };
    NewLayoutForm.prototype.initEvents = function () {
        var _this = this;
        // Add new error message
        this.el.querySelector('.new form').addEventListener('submit', function (e) {
            var name = _this.el.querySelector('.row.name input').value.trim();
            if (!name) {
                e.preventDefault();
                _this.el.querySelector('.row.name').classList.add('save-error');
            }
        });
    };
    return NewLayoutForm;
}());
